import type {
  AddOrganizationMemberBody,
  OrganizationInfo,
  TeamWorkspaceInviteRole,
  UserInfo,
} from '../types';
import apiRequest from './apiRequest';

export type { AddOrganizationMemberBody, TeamWorkspaceInviteRole };

export type PutOrganizationMemberResponse =
  | { organizationInfo: OrganizationInfo; userInfo: UserInfo }
  | { inviteSent: true; email: string };

export default async function putOrganizationMember(
  organizationID: string,
  userIDOrEmailAddress: string,
  body: AddOrganizationMemberBody,
) {
  return apiRequest<PutOrganizationMemberResponse>(
    'user',
    `/organizations/${organizationID}/${encodeURIComponent(userIDOrEmailAddress)}`,
    {
      method: 'PUT',
      body: JSON.stringify(body),
    },
  );
}
